<template>
  <HeroView
      title="Zap"
      text="A visually magnetic Shopify theme designed to maximize sales with conversion-driven features — including quick view, popups, product search, cart drawer, and more."
      purchase-link="https://themes.shopify.com/themes/zap/presets/zap"
      price="$380"
      img-main="/assets/imgs/themes/zap/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/zap/hero/hero.webp 1x, /assets/imgs/themes/zap/hero/hero@2x.webp 2x"
      img-alt=""
  />

  <FichesView/>

  <DemosView
      subheading="5 Sales-Optimized"
      title="pre-designed Presets"
      text="Discover 5 high-impact presets designed to drive sales with optimized layouts and features."
      theme-id="zap"
  />

  <HeroBannerView
      subheading="Immersive"
      title="Hero Banner with search bar"
      text="Grab attention with a hero banner and built-in search for faster shopping and higher conversions."
  />

  <AdvancedView
      subheading="Advanced"
      title="Features for Conversion"
      text="Packed with conversion tools, our theme reduces friction and guides customers from product to checkout."
  />
  <BannerView
      subheading="Build Fast"
      title="Launch the Perfect Store"
      text="Create your store faster using a theme made for speed, refined style, and higher revenue."
      purchase-link="https://themes.shopify.com/themes/zap/presets/zap"
      price="$380"
      img-main="/assets/imgs/themes/zap/banner@2x.webp"
      img-set="/assets/imgs/themes/zap/banner.webp 1x, /assets/imgs/themes/zap/banner@2x.webp 2x"
      img-alt=""
  />
  <FeaturesView/>
  <SubscribeView theme="Zap" :id="1"/>
  <BuiltView/>
  <DocView
      doc-link="/help-center/documentation/zap/"
      img-main="/assets/imgs/themes/zap/doc/doc@2x.webp"
      img-set="/assets/imgs/themes/zap/doc/doc.webp 1x, /assets/imgs/themes/zap/doc/doc@2x.webp 2x"
      img-alt=""
  />
  <FinalView
      subheading="Rollout"
      title="With a theme that performs"
      text="All features are optimized to turn visitors into customers, increase profits, and grow your store faster."
      purchase-link="https://themes.shopify.com/themes/zap/presets/zap"
      price="$380"
      img-main="/assets/imgs/themes/zap/final@2x.webp"
      img-set="/assets/imgs/themes/zap/final.webp 1x, /assets/imgs/themes/zap/final@2x.webp 2x"
      img-alt=""
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import FichesView from '@/components/general/FichesView.vue'
import DemosView from '@/components/general/DemosView.vue'
import HeroBannerView from '@/components/general/HeroBannerView.vue'
import AdvancedView from '@/components/general/AdvancedView.vue'
import BannerView from '@/components/general/BannerView.vue'
import SubscribeView from '@/components/general/SubscribeView.vue'
import FeaturesView from '@/components/general/FeaturesView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'ZapView',
  components: {
    HeroView,
    FichesView,
    DemosView,
    HeroBannerView,
    AdvancedView,
    BannerView,
    SubscribeView,
    FeaturesView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>

<script setup>
import { useHead } from '@vueuse/head'

useHead({
  title: 'Zap – Sales-Driven & Visually Magnetic Shopify Theme',
  meta: [
    { name: 'description', content: 'Zap is an advanced, feature-packed Shopify theme built for growth—bold aesthetics and high-impact tools to maximize your store’s sales.' },

    { property: 'og:title', content: 'Zap – Sales-Driven & Visually Magnetic Shopify Theme' },
    { property: 'og:description', content: 'Advanced, modern, and conversion-focused—everything you need to grow your store fast.' },
    { property: 'og:image', content: '/assets/imgs/themes/zap/og_image.png' },
    { property: 'og:url', content: 'https://almostperfectstudio.com/themes/zap' },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:site_name', content: 'Zap' }
  ]
})
</script>
